import { createContext } from "react";

const ReportDateContext = createContext(null);

export default ReportDateContext;
